<template>
  <div class="index">
    <div class="centered add-webinar">
      <a class="button is-info" @click="handleAddWebinar">+ Добавить темы</a>
    </div>
    <div class="webinars">
      <div class="webinar-wrapper" v-for="webinar in webinars">
        <Webinar :webinar="webinar" :key="webinar.id" @webinar-saved="reloadWebinars"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import Webinar from 'components/Events/Webinar'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Webinars',
  data() {
    return {}
  },
  computed: {
    ...mapState(['webinars'])
  },
  created() {
    this.getWebinars()
    this.getSpeakers()
  },
  methods: {
    ...mapActions(['getWebinars', 'addWebinar', 'getSpeakers']),
    handleAddWebinar() {
      this.addWebinar({
        id: uuidv4(),
        meta: [
          {description: '', presentation: '', selectedSpeakers: []},
          {description: '', presentation: '', selectedSpeakers: []}
        ]
      })
    },
    async reloadWebinars() {
      try {
        // Загрузка обновленного списка вебинаров
        await this.getWebinars()
      } catch (error) {
        console.error("Ошибка при загрузке вебинаров:", error)
      }
    },
  },
  components: { Webinar },
}
</script>

<style scoped>
@import "../../global.css";
.webinar-wrapper {
  padding: 20px;
  margin: 30px 0;
  background: #eee;
}
.webinars {
  max-width: 1200px;
  margin: 25px auto;
}
.add-webinar {
  margin: 20px 0 30px
}
</style>



// WEBPACK FOOTER //
// Themes.vue?66b43929